import ApiService from './ApiService'
import { BASE_URL, CONFIG } from '../utils/helperConstants'
import { postData } from 'utils/restService'

export async function apiSignIn(payload) {
    return await postData('amp/auth/v1/login', payload, true)
}

export async function apiSignUp(data) {
    return ApiService.fetchData({
        url: '/sign-up',
        method: 'post',
        data,
    })
}

export async function apiSignOut(data) {
    localStorage.clear()
    //No APi available for logout yet
    // return ApiService.fetchData({
    //     url: '/sign-out',
    //     method: 'post',
    //     data,
    // })
}

export async function apiForgotPassword(data) {
    return ApiService.fetchData({
        url: '/forgot-password',
        method: 'post',
        data,
    })
}

export async function apiResetPassword(data) {
    return ApiService.fetchData({
        url: '/reset-password',
        method: 'post',
        data,
    })
}
